import { Form as AntdForm } from "antd";

import { useForm } from "./hooks";
import { FormProps } from "./types";

// eslint-disable-next-line react/function-component-definition
function Form<T = unknown>(props: FormProps<T>): JSX.Element {
  const { children, ...formProps } = useForm(props);

  return <AntdForm<T> {...formProps}>{children}</AntdForm>;
}

export default Form;
